import { render } from "./help-card.vue?vue&type=template&id=2e1f09db&ts=true"
import script from "./help-card.vue?vue&type=script&lang=ts"
export * from "./help-card.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/univerza-maribor/brium/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__